import React, { useEffect, useContext } from 'react';
import TagManager from 'react-gtm-module';
import Box from '@material-ui/core/Box';
import { Helmet } from 'react-helmet';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Switch, Route } from 'react-router-dom';
import md5 from 'md5';

import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';

import { useQuery } from '@apollo/react-hooks';
import { GET_TENANT_INFO } from '../../graphql/tenant';
import { Layout } from '../Layout';
import { ScriptsContext } from '../../context/ScriptsContext';
import { RXDLayout } from '../RXDLayout';
import useStyles from './styles';
import { GET_WP_USER_INFO } from '../../graphql/user';

const CommonLayout = () => {
  const classes = useStyles();
  const { setAnalyticScriptLoaded } = useContext(ScriptsContext);

  const { data: tenantData } = useQuery(GET_TENANT_INFO);
  const tenant = tenantData?.getTenantInfo;

  const customCss = tenant?.custom_css;

  const { data: userData, loading: userLoading } = useQuery(GET_WP_USER_INFO, {
    errorPolicy: 'all',
  });

  const userInfo = userData?.getWPUserInfo;

  // useEffect(() => {
  //   // eslint-disable-next-line no-console
  //   console.log('set host');
  //   setHasNews(!host?.includes('sustainabilityunlocked'));
  // }, [setHasNews, host]);

  useEffect(() => {
    const dataLayerInfo = {};
    if (userInfo?.id) {
      dataLayerInfo['userid'] = md5(userInfo.id);
      dataLayerInfo['email'] = userInfo.email;
      if (userInfo.username) dataLayerInfo['username'] = userInfo.username;
      if (userInfo?.teams_where_learner?.[0]) {
        dataLayerInfo['teamname'] = userInfo.teams_where_learner[0]?.name;
        dataLayerInfo['teamid'] = userInfo.teams_where_learner[0]?.id;
      } else if (userInfo.teams_where_manager?.[0]) {
        dataLayerInfo['teamname'] = userInfo.teams_where_manager[0]?.name;
        dataLayerInfo['teamid'] = userInfo.teams_where_manager[0]?.id;
      }
    }

    if (
      typeof window !== 'undefined' &&
      typeof document !== 'undefined' &&
      tenant?.gtm_id !== undefined
    ) {
      const tagManagerArgs = {
        gtmId: tenant?.gtm_id,
        dataLayer: dataLayerInfo,
      };

      TagManager.initialize(tagManagerArgs);
    }
  }, [tenant, userInfo]);

  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles?.parentNode?.removeChild(jssStyles);
    }

    if (process.env.REACT_APP_VERSE_SCRIPT) {
      const script = document.createElement('script');

      script.src = process.env.REACT_APP_VERSE_SCRIPT;
      script.async = true;

      document.body.appendChild(script);

      script.onload = () => {
        if (window) {
          const videoEvents = window?.videoEvents?.default;
          if (videoEvents) {
            window.verseEvents = new videoEvents(null);
            setAnalyticScriptLoaded(true);
          }
        }
      };
    }
  }, [setAnalyticScriptLoaded]);

  return (
    <I18nextProvider i18n={i18n}>
      <Box className={classes.container}>
        <CssBaseline />
        <Helmet>
          <style>{customCss}</style>
        </Helmet>
        <Switch>
          <Route
            path="/rxd"
            render={(props) => (
              <RXDLayout tenant={tenant} userInfo={userInfo} userLoading={userLoading} {...props} />
            )}
          />
          <Route
            path="/"
            render={(props) => (
              <Layout tenant={tenant} userInfo={userInfo} userLoading={userLoading} {...props} />
            )}
          />
        </Switch>
      </Box>
    </I18nextProvider>
  );
};

export default CommonLayout;
